export default {
  transactionCostIdeal: '*0.25 EUR transaction cost included',
  transactionCostCreditCard:
    '*0.25 EUR transaction cost + 1% of order cost is included',
};
